(function($) {
	
gsap.registerPlugin(ScrollTrigger);
gsap.registerPlugin(ScrollToPlugin);

// Object Fit Polyfill for IE

if (Modernizr.objectfit) {
  console.log('objectfit supported')
} else {
  Array.prototype.forEach.call(document.querySelectorAll('.object-fit'), function (el) {
	  const image = el.querySelector('img');
	  
	  el.style.backgroundImage = 'url(' + image.src + ')';
	  el.classList.add('object-fit-active');
  });
  
  const development = document.querySelector('.development');
  
  if (development) {
	  development.classList.add('reverse');
  }
}

let x, y

const MathUtils = {
	lineEq: function(y2, y1, x2, x1, currentVal) {
		const m = (y2 - y1) / (x2 - x1);
		const b = y1 - m * x1;
		return m * currentVal + b;
	},
	lerp: function(a, b, n) { return (1 - n) * a + n * b },
	getRandomFloat: function(min, max) { return (Math.random() * (max - min) + min).toFixed(2) }
};

let winsize;
function calcWinsize() {
	return winsize = {
		width: window.innerWidth,
		height: window.innerHeight
	};
}

calcWinsize();
window.addEventListener('resize', calcWinsize);

function getMousePos(ev) {
	let posx = 0;
	let posy = 0;
	if (!ev) e = window.event;
	if (ev.pageX || ev.pageY)   {
		posx = ev.pageX;
		posy = ev.pageY;
	}
	else if (ev.clientX || ev.clientY)  {
		posx = ev.clientX + body.scrollLeft + docEl.scrollLeft;
		posy = ev.clientY + body.scrollTop + docEl.scrollTop;
	}
	return { x : posx, y : posy }
}

let mousepos = {x: winsize.width/2, y: winsize.height/2};
window.addEventListener('mousemove', function(ev) {
	mousepos = getMousePos(ev)
});

document.addEventListener('mousemove', function(ev) {
	x = ev.clientX
	y = ev.clientY
})

// set the starting position of the cursor outside of the screen
let clientX = -100;
let clientY = -100;
const innerCursor = document.querySelector(".cursor--small");

function initCursor() {
  // add listener to track the current mouse position
  document.addEventListener("mousemove", function(e) {
	clientX = e.clientX;
	clientY = e.clientY;
  });
  
  // transform the innerCursor to the current mouse position
  // use requestAnimationFrame() for smooth performance
  function render() {
	gsap.set(innerCursor, {
	  x: clientX,
	  y: clientY
	});
	
	requestAnimationFrame(render);
  };
  requestAnimationFrame(render);
};

function cursorEnter() {
	gsap.to(innerCursor, 0.225, {
	 scale: 1
	});
}

function cursorLeave() {
	gsap.to(innerCursor, 0.225, {
	 scale: 0.4
	});
}

Array.prototype.forEach.call(document.querySelectorAll('a, .link'), function(el, i){
	el.addEventListener('mouseenter', function() {cursorEnter()});
	el.addEventListener('mouseleave', function() {cursorLeave()});
});	

initCursor();


// 	Header
var header = document.querySelector("header.site-header");
// construct an instance of Headroom, passing the element
var headroom  = new Headroom(header);
// initialise
headroom.init();


// Back to Top Button

const backToTop = document.querySelector('button.backtotop');

backToTop.addEventListener('click', function() {
	gsap.to(window, {scrollTo: 0});
})

///// Section Dropdowns

function toggleDropdown() {
  const dropdown = document.querySelector(".sub-navigation-container");
  dropdown.classList.toggle("hide");

  const input = document.querySelector(".sub-navigation-header");
  input.classList.toggle("input__active");
};

function selectOption(name) {
  const text = document.querySelector('.placeholder');
  text.textContent = name;
  text.classList.add('sub-navigation-header__selected')
  toggleDropdown();
};

const input = document.querySelector(".sub-navigation-header");
if(input) {
	input.addEventListener("click", toggleDropdown);
}

const options = document.querySelectorAll(".sub-navigation-container a");
if(options) {
	Array.prototype.forEach.call(options, function(option) {
		option.addEventListener("click", toggleDropdown);
	})
}

const intro = document.querySelector('.intro')
const subNavigation = document.querySelector('.sub-navigation')

if (subNavigation) {
	intro.classList.add('subnav')
}


// 	Overlay
var triggerBttn = document.getElementById('trigger-overlay'),
	overlay = document.querySelector('div.overlay'),
	closeBttn = overlay.querySelector('button.overlay-close');
navLinks = document.querySelectorAll('.overlay ul li a');
(transEndEventNames = {
	WebkitTransition: 'webkitTransitionEnd',
	MozTransition: 'transitionend',
	OTransition: 'oTransitionEnd',
	msTransition: 'MSTransitionEnd',
	transition: 'transitionend',
}),
	(transEndEventName = transEndEventNames[Modernizr.prefixed('transition')]),
	(support = { transitions: Modernizr.csstransitions });

function toggleOverlay() {
	if (overlay.classList.contains('open')) {
		overlay.classList.remove('open');
		overlay.classList.add('close');
		var onEndTransitionFn = function(ev) {
			if (support.transitions) {
				if (ev.propertyName !== 'visibility') return;
				this.removeEventListener(transEndEventName, onEndTransitionFn);
			}
			overlay.classList.remove('close');
		};
		if (support.transitions) {
			overlay.addEventListener(transEndEventName, onEndTransitionFn);
		} else {
			onEndTransitionFn();
		}
	} else if (!overlay.classList.contains('close')) {
		overlay.classList.add('open');
	}
}

triggerBttn.addEventListener('click', toggleOverlay);
closeBttn.addEventListener('click', toggleOverlay);

Array.prototype.forEach.call(navLinks, function(link)  {
	link.addEventListener('click', toggleOverlay);
});

const bodyTag = document.querySelector('body');

/// Allow Time for Sub Menu

var menuItems = document.querySelectorAll('#primary-menu li.menu-item-has-children');
let timer;

Array.prototype.forEach.call(menuItems, function(el, i){
	el.addEventListener("mouseover", function(event){
		const current = document.querySelector("li.menu-item-has-children.open")
		
		if (current) {
			current.classList.remove("open");
		}

		this.classList.add("open");
		clearTimeout(timer);
	});
	el.addEventListener("mouseout", function(event){
		timer = setTimeout(function(event){
			document.querySelector("li.menu-item-has-children.open").classList.remove("open");
		}, 100);
	});
});

var menuItemsScroll = document.querySelectorAll('a[href]');


let scrollPadding

function updatePadding() {
	var w = window.innerWidth;
	const subsection = document.querySelector('.sub-navigation-container')

	if (w > '768') {
		scrollPadding = 80;
	} else if (w <= '768' && subsection) {
		scrollPadding = 135;
	} else {
		scrollPadding = 70;
	}
}

updatePadding()

window.addEventListener("resize", updatePadding)

// Detect if a link's href goes to the current page

function getSamePageAnchor (link) {	
  if (
	link.protocol !== window.location.protocol ||
	link.host !== window.location.host ||
	link.pathname !== window.location.pathname ||
	link.search !== window.location.search
  ) {
	return false;
  }

  return link.hash;
}

// Scroll to a given hash, preventing the event given if there is one
function scrollToHash(hash, e) {
  const elem = hash ? document.querySelector(hash) : false;
  if(elem) {
	if(e) e.preventDefault();
	gsap.to(window, {scrollTo: {y: elem, offsetY: scrollPadding}, onComplete: function() { }});
	
  }
}

Array.prototype.forEach.call(menuItemsScroll, function(a) {
  a.addEventListener('click', function(e) {
	scrollToHash(getSamePageAnchor(a), e);
  });
});

// Scroll to the element in the URL's hash on load

scrollToHash(window.location.hash);

var mobileMenuItems = document.querySelectorAll('#primary-menu-mobile li.menu-item-has-children');

function insertAfter(referenceNode, newNode) {
	referenceNode.parentNode.insertBefore(newNode, referenceNode.nextSibling);
}
	
Array.prototype.forEach.call(mobileMenuItems, function(el, i){	
	const link = el.querySelector('a');
	const drop = document.createElement("div");
	drop.classList.add('overlay-nav-dropdown');
	drop.addEventListener('click', function(ev) {
		if (el.classList.contains('open')) {
			el.classList.remove('open');
		} else {
			el.classList.add('open');
		}
	})
	
	insertAfter(link, drop);
});

// Sub Navigation Scroll To
// 
// Array.prototype.forEach.call(document.querySelectorAll("a"), function(el, i) {
// 	el.addEventListener('click', function(event) {
// 		// Make sure this.hash has a value before overriding default behavior
// 		if (this.hash !== "" && this.pathname === window.location.pathname) {
// 		  // Prevent default anchor click behavior
// 		  event.preventDefault();
// 	
// 		  // Store hash
// 		  var hash = this.hash;
// 	
// 		  // Using jQuery's animate() method to add smooth page scroll
// 		  // The optional number (800) specifies the number of milliseconds it takes to scroll to the specified area
// 		  $('html, body').animate({
// 			scrollTop: $(hash).offset().top
// 		  }, 100, function(){
// 	
// 			// Add hash (#) to URL when done scrolling (default click behavior)
// 			window.location.hash = hash;
// 		  });
// 		} // End if
// 	});
// });


// History Timeline Gradient Dots

const timelineContainers = document.querySelectorAll('.timeline-container');

if (timelineContainers) {
	const numberOfDates = timelineContainers.length
	
	if (Modernizr.arrow) {
		const colorScale = d3.scaleLinear().domain([0, numberOfDates]).range(['#4FB7C2', '#3167A9'])
		
		Array.prototype.forEach.call(timelineContainers, function(el, i) {
			const circle = el.querySelector('span.circle');
			circle.style.background = colorScale(i);
		})
	}
}


// Partners Logos Popups
  
const partnerLogos = document.querySelectorAll('.partners-logo');

Array.prototype.forEach.call(partnerLogos, function(el, i){	
	el.addEventListener("click", function() {
		basicLightbox.create(el.querySelector('template'), {
			onShow: function(instance) {
				instance.element().querySelector('button.close').onclick = instance.close;	
			},
			onClose: function(instance) {
			}
		}).show(function(instance) {
			instance.element().querySelector('button.close').focus()
		});
	
	})
});


// Home Background Video

Object.defineProperty(HTMLMediaElement.prototype, 'playing', {
	get: function(){
		return !!(this.currentTime > 0 && !this.paused && !this.ended && this.readyState > 2);
	}
})

const video = document.getElementById('hero-background-video');

if (video) {
	let playing;
	const videoController = document.querySelector('.pause-video');
	const videoControllerSVG = videoController.querySelector('span.icon');
	const videoControllerText = videoController.querySelector('span.text');
	
	function updateVideo() { 
		if(video.playing) {
			videoControllerText.innerHTML = 'Play Animation';
			videoControllerSVG.innerHTML = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 11.523 13.828" width="15"><path data-name="Polygon 1" d="M11.523 6.914L0 13.828V0z" fill="#fff"/></svg>';
			video.pause();
		} else {
			videoControllerText.innerHTML = 'Pause Animation';
			videoControllerSVG.innerHTML = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 9 12" width="12"><g data-name="Group 245" fill="#fff"><path data-name="Rectangle 482" d="M0 0h3v12H0z"/><path data-name="Rectangle 483" d="M6 0h3v12H6z"/></g></svg>';
			
			video.play();
		}	
	}
	
	videoController.addEventListener("click", function() {
		updateVideo();
	})
	
	const videoOpen = document.querySelector('.play-full');
	
	const instance = basicLightbox.create(
		videoOpen.querySelector('template'),
		{
			onClose: function(instance) {
				if (playing) {
					video.play();
				}
			},
			onShow: function(instance) {
				instance.element().querySelector('a').onclick = instance.close
			}
		}
	)
	
	videoOpen.addEventListener("click", function() {
		playing = video.playing
		instance.show();
		video.pause();
	})
}

// ALL Gallery Sliders

const sliders = document.querySelectorAll('.gallery-slider');

if (sliders) {
	
	Array.prototype.forEach.call(sliders, function(slider) {
		
		const next = slider.querySelector('.swiper-button-next')
		const prev = slider.querySelector('.swiper-button-prev')
		const pagination = slider.querySelector('.swiper-pagination')
		
		const mySwiper = new Swiper(slider, {
			// Optional parameters
			loop: true,

			autoplay: {
				delay: 4000,
			},
			
			effect: 'fade',

			speed: 500,
			
			navigation: {
				nextEl: next,
				prevEl: prev,
			},
			
			// If we need pagination
			  pagination: {
				el: pagination,
			  },

			keyboard: {
				enabled: true,
			},
		});
	})
}

// Home Slider

const homeslider = document.querySelector('.home-slider .swiper-container');

if (homeslider) {
	const mySwiper = new Swiper(homeslider, {
		// Optional parameters
		loop: true,

		autoplay: {
			delay: 4000,
		},

		speed: 500,
		
		navigation: {
			nextEl: '.home-slider .swiper-button-next',
			prevEl: '.home-slider .swiper-button-prev',
		},

		keyboard: {
			enabled: true,
		},
	});
}

// Key Spaces Slider

const keySpaces = document.querySelector('.key-spaces-images.swiper-container');

if (keySpaces) {
	const keySpacesSlides = keySpaces.querySelectorAll('.swiper-slide .key-spaces-image');
	
	const keySpacesSwiper = new Swiper(keySpaces, {
		// Optional parameters
		loop: true,

		effect: 'fade',
		
		autoplay: {
			delay: 4000,
		},

		speed: 500,

		keyboard: {
			enabled: true,
		},
		
		pagination: {
			el: '.key-spaces-nav',
			clickable: true,
			renderBullet: function (index, className) {
			  return '<li class="' + className + '">' + keySpacesSlides[index].dataset.title + '</li>';
			},
		  },
	});
}

// Partners Animation

const partnersHome = document.querySelectorAll('.partners-logo.cycle')

if (partnersHome) {
	Array.prototype.forEach.call(partnersHome, function(el, index) {
		const images = el.querySelectorAll('img')
		const firstImage = images[0]
		const secondImage = images[1]
		
		const tl = gsap.timeline({delay: 5, repeat: -1, repeatDelay: 5})
		tl.to(firstImage, { autoAlpha: 0, duration: 0.75 }, 0);
		tl.to(secondImage, { autoAlpha: 1, duration: 0.75 }, 1);
		tl.to(secondImage, { autoAlpha: 0, duration: 0.75 }, 5);
		tl.to(firstImage, { autoAlpha: 1, duration: 0.75 }, 6);
	})
}

})(jQuery);
